var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductIcon8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "remark/3.1.1-\\u623F\\u8CB8\\u7522\\u54C1-\\u5167\\u9801",
    transform: "translate(-731.000000, -944.000000)",
    stroke: "#A17D58"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group-2",
    transform: "translate(220.000000, 566.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(0.000000, 379.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(512.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8317742,46.8285484 C10.6785484,49.9817742 5.51806452,49.9817742 2.36483871,46.8285484 C-0.788387097,43.6753226 -0.788387097,38.5148387 2.36483871,35.3616129",
    id: "Stroke-1",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.516129,45.9677419 L10.483871,45.9677419",
    id: "Stroke-3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.516129,50 L14.516129,45.9677419",
    id: "Stroke-5",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1682258,3.17145161 C39.3214516,0.0182258065 44.4819355,0.0182258065 47.6351613,3.17145161 C50.7883871,6.32467742 50.7883871,11.4851613 47.6351613,14.6383871",
    id: "Stroke-7",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.483871,0 L35.483871,4.03225806",
    id: "Stroke-9",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.516129,4.03225806 L35.483871,4.03225806",
    id: "Stroke-11",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,35.483871 C50,43.5008065 43.5008065,50 35.483871,50 C27.4669355,50 20.9677419,43.5008065 20.9677419,35.483871 C20.9677419,27.4669355 27.4669355,20.9677419 35.483871,20.9677419 C43.5008065,20.9677419 50,27.4669355 50,35.483871 Z",
    id: "Stroke-13",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.483871,28.2258065 L35.483871,29.8387097",
    id: "Stroke-15",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.483871,41.1290323 L35.483871,42.7419355",
    id: "Stroke-17",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4516129,38.3064516 C31.4516129,39.858871 32.7217742,41.1290323 34.2741935,41.1290323 L36.6935484,41.1290323 C38.2459677,41.1290323 39.516129,39.858871 39.516129,38.3064516 C39.516129,36.7540323 38.2459677,35.483871 36.6935484,35.483871 L35.483871,35.483871 L34.2741935,35.483871 C32.7217742,35.483871 31.4516129,34.2137097 31.4516129,32.6612903 C31.4516129,31.108871 32.7217742,29.8387097 34.2741935,29.8387097 L36.6935484,29.8387097 C37.8129032,29.8387097 38.7846774,30.4983871 39.2403226,31.4483871",
    id: "Stroke-19",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9354839,31.4516129 L4.83870968,31.4516129 C3.9483871,31.4516129 3.22580645,30.7290323 3.22580645,29.8387097 L3.22580645,16.1290323 L0,16.1290323 L0,12.0967742 L15.6451613,0.362903226 C15.9322581,0.147580645 16.3258065,0.147580645 16.6129032,0.362903226 L32.2580645,12.0967742 L32.2580645,16.1290323 L29.0322581,16.1290323 L29.0322581,17.7419355",
    id: "Stroke-21",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-23",
    strokeLinecap: "round",
    points: "3.22580645 8.87096774 3.22580645 0.806451613 8.87096774 0.806451613 8.87096774 4.83870968"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIcon8);
export default __webpack_public_path__ + "static/media/product-icon8.415873654c7c8b592887906e5eeb68db.svg";
export { ForwardRef as ReactComponent };